import { render } from "./TimelineList.vue?vue&type=template&id=b0079c0a"
import script from "./TimelineList.vue?vue&type=script&lang=js"
export * from "./TimelineList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/folklor_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__